import { render } from "./crm-activities-modal.vue?vue&type=template&id=4b8da25a"
import script from "./crm-activities-modal.vue?vue&type=script&lang=js"
export * from "./crm-activities-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__